import apiBase from './apiBase';

export default class Api {
  static async getSchoolNames(text, grade) {
    return await apiBase.get('/api/auto_suggest/school_names', { text, grade });
  }
}
